import useStoreHistory from '../hooks/useStoreHistory';

function HistoryWrapper() {
  useStoreHistory(window.location.pathname); // Init Store History Management
  return null;
}

export default HistoryWrapper;
